var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$t("verification.text")))]),_c('verification-code',{staticClass:"mb-5",attrs:{"email":_vm.email},on:{"verifed":_vm.onVerifed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }